import request from "@/utils/request";
import { FILE_UPLOAD_CODE } from "@/configs";
import { stringify } from "qs";
import { serialize } from "@/utils";
import { ApiLocation } from "@/utils/enhance-request";

/** 文件上传 */
export const postUploadFile = async <T>(data: { file: string | Blob }) => {
  const formData = new FormData();
  formData.append("file", data?.file);
  formData.append("code", FILE_UPLOAD_CODE);
  return await request.post<any, T>(`/api/amazwear-resource/oss/endpoint/put-file`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  });
};

/** 二维码 - 获取 */
export const postQrCodeData = async <T>(data: { originalUrl: string }) => {
  return await request.post<any, T>(`/api/amazwear-health/public/qrCodeManage/queryData`, data);
};

/** 离线地图 - 地区名称 */
export const getOfflinemapTree = async <T = RequestResponse>() => {
  return await request.get<any, T>(`/api/amazwear-user/public/offlineMapInfo/threeLevelTree`);
};

/** 离线地图 - 地区名称 */
export const getOfflinemapPage = async <T = RequestResponse>(params: any) => {
  return await request.get<any, T>(`/api/amazwear-user/public/offlineMapInfo/page?${stringify(params)}`);
};

/** 获取国际化内容 */
export const postGetI18nContent = async <T>(data: any) => {
  return await request.post<any, T>("/api/amazwear-health/public/content/query", data, {
    params: data,
    paramsSerializer: serialize,
  });
};

/** 扫码登录 - 获取二维码 */
export const postLoginQrCode = async <T>({ __api_location, ...rest }: { uuid: string; __api_location?: ApiLocation }) => {
  return await request.post<any, T>(`/api/amazwear-user/public/qr-login/generate`, rest, {
    params: {
      quietness: true,
      __api_location,
    },
  });
};

/** 扫码登录 - 查询登录状态
 *- WAITING(0, "待扫码"),
 *- SCANNED(1, "已扫码待确认"),
 *- CONFIRMED(2, "已确认登录"),
 *- EXPIRED(3, "已过期"),
 *- CANCELLED(4, "已取消");
 */
export const getLoginQrCodeStatus = async <T>({ __api_location, ...rest }: { uuid: string; __api_location?: ApiLocation }) => {
  return await request.get<any, T>(`/api/amazwear-user/public/qr-login/status/${rest.uuid}`, {
    params: {
      quietness: true,
      __api_location,
    },
  });
};

/** 获取用户信息 */
export const postUserInfo = async <T>() => {
  return await request.post<any, T>("/api/amazwear-user/app/user/userInfo");
};
